<template>
  <Card class="mt-2">
    <template #title> Settings </template>
    <template #content>
      <div class="grid">
        <div class="field col-12 md:col-6 lg:col-4">
          <div>{{ required ? 'Required' : 'Not Required' }}</div>
          <InputSwitch v-model="required" />
        </div>
      </div>
    </template>
  </Card>
  <Divider></Divider>
  <Card>
    <template #title> Component </template>
    <template #content>
      <form class="mt-5" @submit.prevent="submitForm">
        <Gender v-model="gender" :required="required"></Gender>
        <Button type="submit" label="Submit" @click.prevent="v.$validate"></Button>
      </form>
    </template>
  </Card>
  <Divider></Divider>
  <Card>
    <template #title> Output </template>
    <template #content>
      <p>{{ gender }}</p>
    </template>
  </Card>
  <p v-for="error of v.$errors" :key="error.$uid">
    {{ error.$message }}
  </p>
</template>
<script setup>
import { ref } from 'vue'
import Gender from '@/components/input/Gender.vue'
import useValidate from '@vuelidate/core'

const required = ref(true)
const gender = ref('')
const v = useValidate()

const submitForm = async () => {
  const result = await v.value.$validate()
  if (result) {
    alert('success')
  } else {
    alert('error')
  }
}
</script>
